module.exports = __webpack_public_path__ + "img/infoq-intro.690af4f2.png";